import { createSelector } from '@ngrx/store';
import { IAppState } from '../../common/interfaces/app-state.interface';
import { IHydrationStatusStore } from '../interfaces/hydration-status-store.interface';

export const selectHydrationStatusStore = (state: IAppState) =>
  state.hydrationStatus;

export const selectAllHydrationStatus = createSelector(
  selectHydrationStatusStore,
  (hydationStatusStore: IHydrationStatusStore) => ({
    hydrationRole: hydationStatusStore.hydrationRole,
    hydrationSource: hydationStatusStore.hydrationSource,
  }),
);
